module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8744/img/favicon-dark.png"